import {useFetcher, useSubmit} from '@remix-run/react'

import {type Memory} from '~/models/memory/memory.server'
import {Toggle} from '~/ui/Toggle'
import {type ToggleMemoryAction} from '../_action.memory'
import {useActiveMemories} from './MemoryHandler'

export const ToggleMemory = ({
  memory,
}: {
  memory: Memory & {isActive: boolean}
}) => {
  const fetcher = useFetcher<ToggleMemoryAction>()
  const submit = useSubmit()
  const activeMemoriesContext = useActiveMemories()
  return (
    <fetcher.Form
      action="/memory"
      method="post"
      onChange={(e) => {
        submit(e.currentTarget, {navigate: false})
        activeMemoriesContext?.onActiveMemoriesChange()
      }}
      className="flex items-center"
    >
      <input type="hidden" name="memoryId" value={memory.id} />
      <input type="hidden" name="_action" value="toggleMemory" />
      <Toggle
        defaultChecked={memory.isActive}
        name="isActive"
        disabled={fetcher.state != 'idle'}
      />
    </fetcher.Form>
  )
}
